const cssVar = (varName: string) => {
  const styles = getComputedStyle(document.documentElement);
  return styles.getPropertyValue(varName);
};

export default cssVar;
